import React, { useRef, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { UsersListWidget } from '../../components/users-list-widget'
import {
    useUserGetFilteredQuery,
    UserGetFilteredApiArg,
    useUserActivateUserMutation,
} from '../../../common/redux/api/web-api'
import { UsersSearchListWidget } from '../../components/users-search-list-widget'
import { PageLayoutContainer } from '../../../lib/page-layout-container'
import useText from '../../../common/hooks/useText'

export type UsersPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

const searchFilterValue: UserGetFilteredApiArg = {
    firstName: '',
    lastName: '',
    email: '',
}

export const UsersPage = React.memo(function UsersPage({ className, style }: UsersPageProps): React.ReactElement {
    const text = useText()
    const formRef = React.useRef<null | HTMLFormElement>(null)
    const filtersContainerRef = useRef<HTMLDivElement | null>(null)
    const [currentPage, setCurrentPage] = useState(0)
    const [activateUser] = useUserActivateUserMutation({})
    const [filter, setFilter] = useState<UserGetFilteredApiArg>({
        ...searchFilterValue,
    })

    const handlePageClick = (selected: number) => {
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0)
        setCurrentPage(selected)
    }
    const pageClick = () => {
        setCurrentPage(0)
    }

    const {
        currentData: usersData,
        refetch,
        isFetching: fetchingData,
    } = useUserGetFilteredQuery({
        noOfItems: 1000,
        firstName: filter?.firstName,
        lastName: filter?.lastName,
        email: filter?.email,
        isSuperAdmin: filter?.isSuperAdmin,
    })

    const filterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()
        const { userFirstName, userLastName, userEmail, adminStatus } = e?.currentTarget.elements as any

        const filterObj = {
            firstName: userFirstName?.value.length > 0 ? userFirstName.value : '',
            lastName: userLastName?.value.length > 0 ? userLastName.value : '',
            email: userEmail?.value.length > 0 ? userEmail.value : '',
            isSuperAdmin: adminStatus.checked === true ? true : undefined,
        }

        setFilter({ ...filter, ...filterObj })
        pageClick()
    }

    const clearForm = (e?: React.FormEvent<HTMLButtonElement>) => {
        e?.preventDefault()
        formRef.current?.reset()
        setFilter({ ...searchFilterValue })
    }

    const useractivate = async (userId: string) => {
        if (confirm(text('msgActivateUser')))
            try {
                await activateUser({ userId }).unwrap()

                refetch()
            } catch (e) {
                console.error(e)
            }
    }

    return (
        <PageLayoutContainer className={cn(className)} style={style}>
            <UsersSearchListWidget onSubmit={filterSubmit} clearForm={clearForm} formRef={formRef} />
            <UsersListWidget
                usersData={usersData}
                currentPage={currentPage}
                handlePageClick={handlePageClick}
                pageClick={pageClick}
                setCurrentPage={setCurrentPage}
                useractivate={useractivate}
                fetchingData={fetchingData}
            />
        </PageLayoutContainer>
    )
})
